// import React, { useEffect, useState } from "react";
// import { Form, Toast, ToastContainer } from "react-bootstrap";

// type FileValue = string | File | (string | File)[] | null;

// interface FileUploadProps {
//   label?: string;
//   multiple?: boolean;
//   maxFiles?: number; // max number of files allowed
//   value: any;
//   existingFiles?: string[];
//   onChange: (
//     files: File | File[] | string | string[] | (File | string)[] | null,
//   ) => void;
//   onRemoveExisting?: (index: number) => void; // optional
// }

// interface PreviewItem {
//   file: File | null;
//   previewUrl: string;
//   filename: string;
// }

// const FileUpload: React.FC<FileUploadProps> = ({
//   label,
//   multiple = true,
//   maxFiles = Infinity,
//   value,
//   existingFiles,
//   onChange,
//   onRemoveExisting,
// }) => {
//   const [previewFiles, setPreviewFiles] = useState<PreviewItem[]>([]);
//   const [showToast, setShowToast] = useState(false);
//   const [toastMsg, setToastMsg] = useState("");
//   const [newPreviews, setNewPreviews] = useState<PreviewItem[]>([]);

//   // Helper function to check if file is an image
//   const isImageFile = (filename: string): boolean => {
//     const imageExtensions = [
//       ".jpg",
//       ".jpeg",
//       ".png",
//       ".gif",
//       ".bmp",
//       ".webp",
//       ".svg",
//     ];
//     const lowerFilename = filename.toLowerCase();
//     return imageExtensions.some((ext) => lowerFilename.endsWith(ext));
//   };

//   // Helper function to extract filename
//   const getFilename = (item: string | File): string => {
//     if (typeof item === "string") {
//       // Extract filename from URL
//       const urlParts = item.split("/");
//       return urlParts[urlParts.length - 1].split("?")[0];
//     } else {
//       return item.name;
//     }
//   };

//   // Generate preview URLs for both File & string URLs
//   useEffect(() => {
//     if (!value) {
//       setNewPreviews([]);
//       return;
//     }

//     const files = Array.isArray(value) ? value : [value];

//     const previews = files.map((file) => ({
//       file,
//       previewUrl: URL.createObjectURL(file),
//       filename: file.name,
//     }));

//     setNewPreviews(previews);

//     return () => {
//       previews.forEach((p) => URL.revokeObjectURL(p.previewUrl));
//     };
//   }, [value]);

//   // Handle File Input
//   const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const files = event.target.files;
//     if (!files) return;

//     const newFiles = Array.from(files);

//     if (multiple) {
//       const existing = Array.isArray(value) ? value : value ? [value] : [];
//       const combined = [...existing, ...newFiles];

//       if (combined.length > maxFiles) {
//         setToastMsg(`Maximum ${maxFiles} files allowed`);
//         setShowToast(true);
//         return;
//       }

//       onChange(combined);
//     } else {
//       onChange(newFiles[0] || null);
//     }

//     event.target.value = "";
//   };
//   // Remove file from preview
//   const removeNewFile = (index: number) => {
//     if (!value) return;

//     const arr = Array.isArray(value) ? [...value] : [value];
//     arr.splice(index, 1);

//     onChange(arr.length ? arr : null);
//   };

//   return (
//     <div>
//       {label && <Form.Label>{label}</Form.Label>}

//       <Form.Control
//         type="file"
//         multiple={multiple}
//         accept=".pdf,.jpg,.jpeg,.png"
//         onChange={handleFileChange}
//       />

//       {/* Preview List */}
//       {/* Existing Documents */}
//       {existingFiles && existingFiles.length > 0 && (
//         <div className="mt-3">
//           <strong>Existing Documents</strong>
//           <div className="d-flex flex-column gap-2 mt-2">
//             {existingFiles.map((url, index) => {
//               const filename = url.split("/").pop()?.split("?")[0] || "file";
//               return (
//                 <div
//                   key={index}
//                   className="d-flex justify-content-between align-items-center p-2 border rounded bg-light"
//                 >
//                   <span
//                     style={{ cursor: "pointer", color: "#0d6efd" }}
//                     onClick={() => window.open(url, "_blank")}
//                   >
//                     {filename}
//                   </span>

//                   {onRemoveExisting && (
//                     <button
//                       type="button"
//                       className="btn btn-sm btn-danger"
//                       onClick={(e) => {
//                         e.preventDefault(); // ✅ prevent form submit
//                         e.stopPropagation();
//                         onRemoveExisting(index);
//                       }}
//                     >
//                       ×
//                     </button>
//                   )}
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       )}

//       {/* New Documents */}
//       {newPreviews.length > 0 && (
//         <div className="mt-3">
//           <strong>New Documents</strong>
//           <div className="d-flex flex-column gap-2 mt-2">
//             {newPreviews.map((item, index) => (
//               <div
//                 key={index}
//                 className="d-flex justify-content-between align-items-center p-2 border rounded"
//               >
//                 <span className="text-truncate">{item.filename}</span>
//                 <button
//                   type="button"
//                   className="btn btn-sm btn-danger"
//                   onClick={(e) => {
//                     e.preventDefault(); // ✅ prevent form submit
//                     e.stopPropagation(); // ✅ stop bubbling
//                     removeNewFile(index);
//                   }}
//                 >
//                   ×
//                 </button>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Toast Message */}
//       <ToastContainer position="top-end" className="p-3">
//         <Toast
//           bg="danger"
//           show={showToast}
//           delay={3000}
//           autohide
//           onClose={() => setShowToast(false)}
//         >
//           <Toast.Body className="text-white">{toastMsg}</Toast.Body>
//         </Toast>
//       </ToastContainer>
//     </div>
//   );
// };

// export default FileUpload;


import React, { useEffect, useState } from "react";
import { Form, Toast, ToastContainer } from "react-bootstrap";

type FileValue = string | File | (string | File)[] | null;

interface FileUploadProps {
  label?: string;
  multiple?: boolean;
  maxFiles?: number; // max number of files allowed
  value: any;
  existingFiles?: string[];
  onChange: (
    files: File | File[] | string | string[] | (File | string)[] | null,
  ) => void;
  onRemoveExisting?: (index: number) => void; // optional
}

interface PreviewItem {
  file: File | null;
  previewUrl: string;
  filename: string;
}

const FileUpload: React.FC<FileUploadProps> = ({
  label,
  multiple = true,
  maxFiles = Infinity,
  value,
  existingFiles,
  onChange,
  onRemoveExisting,
}) => {
  const [previewFiles, setPreviewFiles] = useState<PreviewItem[]>([]);
  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [newPreviews, setNewPreviews] = useState<PreviewItem[]>([]);

  // Helper function to check if file is an image
  const isImageFile = (filename: string): boolean => {
    const imageExtensions = [
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".bmp",
      ".webp",
      ".svg",
    ];
    const lowerFilename = filename.toLowerCase();
    return imageExtensions.some((ext) => lowerFilename.endsWith(ext));
  };

  // Helper function to extract filename
  const getFilename = (item: string | File): string => {
    if (typeof item === "string") {
      // Extract filename from URL
      const urlParts = item.split("/");
      return urlParts[urlParts.length - 1].split("?")[0];
    } else {
      return item.name;
    }
  };

  // Generate preview URLs for both File & string URLs
  useEffect(() => {
    if (!value) {
      setNewPreviews([]);
      return;
    }

    const files = Array.isArray(value) ? value : [value];

    const previews = files
      .filter((file) => file !== null && file !== undefined) // Filter out null/undefined
      .map((file) => {
        // Check if file is a File object or a string URL
        if (file instanceof File) {
          return {
            file,
            previewUrl: URL.createObjectURL(file),
            filename: file.name,
          };
        } else if (typeof file === "string") {
          // It's a URL string, use it directly
          return {
            file: null,
            previewUrl: file,
            filename: getFilename(file),
          };
        } else {
          // Skip invalid items
          return null;
        }
      })
      .filter((item): item is PreviewItem => item !== null); // Type guard to filter out nulls

    setNewPreviews(previews);

    return () => {
      // Only revoke URLs that were created from File objects
      previews.forEach((p) => {
        if (p.file instanceof File && p.previewUrl.startsWith("blob:")) {
          URL.revokeObjectURL(p.previewUrl);
        }
      });
    };
  }, [value]);

  // Handle File Input
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files) return;

    const newFiles = Array.from(files);

    if (multiple) {
      const existing = Array.isArray(value) ? value : value ? [value] : [];
      const combined = [...existing, ...newFiles];

      if (combined.length > maxFiles) {
        setToastMsg(`Maximum ${maxFiles} files allowed`);
        setShowToast(true);
        return;
      }

      onChange(combined);
    } else {
      onChange(newFiles[0] || null);
    }

    event.target.value = "";
  };
  // Remove file from preview
  const removeNewFile = (index: number) => {
    if (!value) return;

    const arr = Array.isArray(value) ? [...value] : [value];
    arr.splice(index, 1);

    onChange(arr.length ? arr : null);
  };

  return (
    <div>
       {label && <Form.Label>{label}</Form.Label>}

      <Form.Control
        type="file"
        multiple={multiple}
        accept=".pdf,.jpg,.jpeg,.png"
        onChange={handleFileChange}
      />

      {/* Preview List */}
      {/* Existing Documents */}
      {existingFiles && existingFiles.length > 0 && (
        <div className="mt-3">
          <strong>Existing Documents</strong>
          <div className="d-flex flex-column gap-2 mt-2">
            {existingFiles.map((url, index) => {
              const filename = url.split("/").pop()?.split("?")[0] || "file";
              return (
                <div
                  key={index}
                  className="d-flex justify-content-between align-items-center p-2 border rounded bg-light"
                >
                  <span
                    style={{ cursor: "pointer", color: "#0d6efd" }}
                    onClick={() => window.open(url, "_blank")}
                  >
                    {filename}
                  </span>

                  {onRemoveExisting && (
                    <button
                      type="button"
                      className="btn btn-sm btn-danger"
                      onClick={(e) => {
                        e.preventDefault(); // ✅ prevent form submit
                        e.stopPropagation();
                        onRemoveExisting(index);
                      }}
                    >
                      ×
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* New Documents */}
      {newPreviews.length > 0 && (
        <div className="mt-3">
          <strong>New Documents</strong>
          <div className="d-flex flex-column gap-2 mt-2">
            {newPreviews.map((item, index) => (
              <div
                key={index}
                className="d-flex justify-content-between align-items-center p-2 border rounded"
              >
                <span className="text-truncate">{item.filename}</span>
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={(e) => {
                    e.preventDefault(); // ✅ prevent form submit
                    e.stopPropagation(); // ✅ stop bubbling
                    removeNewFile(index);
                  }}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Toast Message */}
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg="danger"
          show={showToast}
          delay={3000}
          autohide
          onClose={() => setShowToast(false)}
        >
          <Toast.Body className="text-white">{toastMsg}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default FileUpload;
